export const TEXT_DIRECTION = {
  ALL: "",
  LEFT_TO_RIGHT: 0,
  RIGHT_TO_LEFT: 1,
};

export const textDirectionLabels = () => {
  return {
    [TEXT_DIRECTION.LEFT_TO_RIGHT]: "Left-to-Right",
    [TEXT_DIRECTION.RIGHT_TO_LEFT]: "Right-to-Left",
  };
};

export const textDirectionFormOptions = () => [
  { value: TEXT_DIRECTION.LEFT_TO_RIGHT, label: textDirectionLabels()[TEXT_DIRECTION.LEFT_TO_RIGHT] },
  { value: TEXT_DIRECTION.RIGHT_TO_LEFT, label: textDirectionLabels()[TEXT_DIRECTION.RIGHT_TO_LEFT] },
];

export const textDirectionFilters = () => [
  { value: TEXT_DIRECTION.ALL, label: "All Options" },
  { value: TEXT_DIRECTION.LEFT_TO_RIGHT.toString(), label: textDirectionLabels()[TEXT_DIRECTION.LEFT_TO_RIGHT] },
  { value: TEXT_DIRECTION.RIGHT_TO_LEFT.toString(), label: textDirectionLabels()[TEXT_DIRECTION.RIGHT_TO_LEFT] },
];
